import { Container } from "react-bootstrap";
import LoadingSection from "../../atoms/loadingsection/LoadingSection";
import ProjectList from "./projectlist/ProjectList";
import { useGetApiProjects } from "../../../api/generated/endpoints/project/project";
import { PROJECT_LIST_QUERY_OPTIONS } from "./projectListQueryOptions";

const Projects: React.FC = () => {
  const { data: projects, error: projectsError, status: projectsStatus, isFetching: isProjectsLoading, refetch } = useGetApiProjects({
    query: PROJECT_LIST_QUERY_OPTIONS,
  });

  const refetchProjects = () => {
    refetch();
  }

  if (projectsStatus === "pending"){ return <LoadingSection text="Laddar.." /> }
  if (projectsStatus === "error") { return <div>Error loading projects: {projectsError?.message}</div> };

  return(
      <Container className="">
      <ProjectList
        loading={isProjectsLoading}
        key={JSON.stringify(projects?.listOfProjectDto)}
        title="Projekt"
        listOfProjectDto={projects?.listOfProjectDto || []}
        refetchProjects={refetchProjects}
        baseUrl="/projects"
      />
      </Container>
  )
}

export default Projects;